module.exports = __webpack_public_path__ + "static/media/2-en.73d5f78c.svg";